































import { Vue, Component, Prop } from 'vue-property-decorator';
import { SimpleUspBlockViewModel, Media } from '@/types/contentServerContract';
import { hexToRgb, isValidHexColor } from '@/core/color/color.service';
import tailwind from '@/styling/tailwind.config';
import breakpointState from '@/core/responsive/breakpoints/breakpointsState.observable';
import { MAX_SM } from '@/core/config/breakpointConfig';
export interface SimpleUspBlockItemViewModel {
    icon?: Media;
    text?: string;
}
@Component
export default class HeroBannerUniqueSellingPointsBlock extends Vue {
    @Prop({
        required: true,
        type: Object
    }) content!: SimpleUspBlockViewModel;

    @Prop({
        required: true,
        type: Boolean
    }) isFirstBlock!: boolean;

    uniqueSellingPointsMobileClasses: string[] = [];

    mounted() {
        // Randomize what UPS are shown on mobile.
        this.uniqueSellingPointsMobileClasses = ['flex', 'flex'];
        if (this.content.uniqueSellingPointItems?.length) {
            for (let i:number = 2; i < this.content.uniqueSellingPointItems.length; i++) {
                this.uniqueSellingPointsMobileClasses.push('hidden md:flex');
            }
            this.uniqueSellingPointsMobileClasses.sort(() => Math.random() - 0.5);
        }
    }

    get uspStyle(): Partial<CSSStyleDeclaration> | null {
        const style: Partial<CSSStyleDeclaration> = {};
        if (this.uniqueSellingPointsColor) {
            style.color = this.uniqueSellingPointsColor;
        }
        if (this.uniqueSellingPointsBackgroundColor) {
            style.backgroundColor = this.uniqueSellingPointsBackgroundColor;
        }
        return style;
    }

    get uniqueSellingPointsBackgroundColor() {
        return '#262422'; // Hardcoded for now
    }

    get uniqueSellingPointsColor() {
        return '#ffffff'; // Hardcoded for now
    }

    isIconExtensionSvg(icon:Media): boolean {
        return icon?.extension?.toLowerCase() === 'svg';
    }

    svgIconStyle(icon: Media): Partial<CSSStyleDeclaration> {
        if (this.isIconExtensionSvg(icon)) {
            // Set background color to text color and set mask to SVG icon, if icon is SVG. That makes it possible to set fill color of umbraco SVGs.
            return {
                backgroundColor: this.uniqueSellingPointsColor,
                // @ts-ignore
                '-webkit-mask': `url("${icon.url}") no-repeat center`,
                '-webkit-mask-size': '100% auto',
                mask: `url("${icon.url}") no-repeat center`,
                maskSize: '100% auto'
            };
        }
        return {};
    }

    colorStyle(hexColor: string): string {
        const EETBlack = tailwind.theme.colors.black;
        return hexColor ? this.hexToRgbWithDefault(hexColor) : EETBlack;
        // Reuse from ImageTextVideoBlock.vue, but we might not have contentBackgroundColor in this content.
        // return this.contentBackgroundColor === 'white' ? EETBlack : hexColor ? this.hexToRgbWithDefault(hexColor) : EETBlack;
    }

    hexToRgbWithDefault(hex: string, alpha?: number): string {
        if (!isValidHexColor(hex)) return tailwind.theme.colors.black;
        return hexToRgb(hex, alpha);
    }

    isColorDefined(color: string): boolean {
        return color?.length === 7 ?? false; // #233445
    }

    get isMobile() {
        return breakpointState.isBreakpointActive(MAX_SM);
    }

    get uspItems(): { content: SimpleUspBlockItemViewModel }[] {
        return this.content.uniqueSellingPointItems || [];
    }

    get appendToPreviousBlock() {
        return this.content.appendToPreviousBlock && !this.isFirstBlock;
    }
}
